import { render, staticRenderFns } from "./DashboardEditorsTooltip.vue?vue&type=template&id=5a6db9a6&scoped=true"
import script from "./DashboardEditorsTooltip.vue?vue&type=script&lang=js"
export * from "./DashboardEditorsTooltip.vue?vue&type=script&lang=js"
import style0 from "./DashboardEditorsTooltip.vue?vue&type=style&index=0&id=5a6db9a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6db9a6",
  null
  
)

export default component.exports